<template>
  <div
    class="view"
    :style="{ paddingTop: $route.query.active ? 0 : navbarheight }"
    style="padding-bottom: 0"
  >
    <div class="content" style="height: 100%; padding-bottom: 0">
      <my-top
        v-if="!$route.query.active"
        :title="
          $route.query.webTitle ||
          (urlList[$route.query.webType] &&
            urlList[$route.query.webType].name) ||
          '视频监控'
        "
        lefttext="返回"
        @leftclick="
          $route.query.backUrl
            ? togo($route.query.backUrl)
            : $route.query.goHistory
            ? $router.go(-1)
            : togo('/project')
        "
      ></my-top>
      <iframe
        id="frameWrapper"
        v-if="url"
        width="100%"
        :style="[{ height: $route.query.active ? `calc(100vh - 5rem)` : `calc(100vh - ${navbarheight})` }]"
        :src="url"
        frameborder="0"
        allowfullscreen="true"
        webkitallowfullscreen="true"
        mozallowfullscreen="true"
        oallowfullscreen="true"
        msallowfullscreen="true"
      ></iframe>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import CSCEC from '@/core/cscec/cscec'

export default {
  name: 'Webview',
  data() {
    return {
      url: '',
      urlList: {
        hr_01: {
          id:
            'https://hr.cscecxn.com/api/auth/login_by_sso?sso=customer_sso&next=/%23/signin/punchin&token=' +
            store.state.user.token,
          name: '移动签到',
        },
        hr_02: {
          id:
            'https://hr.cscecxn.com/api/auth/login_by_sso?sso=customer_sso&next=/%23/bill_query/brief&token=' +
            store.state.user.token,
          name: '工资单',
        },
        hr_03: {
          id:
            'https://hr.cscecxn.com/api/auth/login_by_sso?sso=customer_sso&next=/%23/time_my_leave&token=' +
            store.state.user.token,
          name: '休假申请',
        },
        hr_05: {
          id:
            'https://hr.cscecxn.com/api/auth/login_by_sso?sso=customer_sso&next=/%23/time_my_trip&token=' +
            store.state.user.token,
          name: '出差申请',
        },
        hr_06: {
          id:
            'https://hr.cscecxn.com/api/auth/login_by_sso?sso=customer_sso&next=/%23/time_my_fill&token=' +
            store.state.user.token,
          name: '补签申请',
        },
        // hr_06: {
        //   id:
        //     'https://hr.cscecxn.com/api/auth/login_by_sso?sso=customer_sso&next=/%23/index&token=' +
        //     store.state.user.token,
        //   name: '人力资源',
        // },
        hr: {
          id:
            'https://hr.cscecxn.com/api/auth/login_by_sso?sso=customer_sso&next=/%23/index&token=' +
            store.state.user.token,
          name: '人力资源',
        },
      },
    }
  },
  created() {
    this.url = this.$route.query.webUrl
      ? this.$route.query.webUrl
      : this.$route.query.webType
      ? this.urlList[this.$route.query.webType]?.id
      : 'https://build.cscecxn.com:4443/#/projectSelection?token=' +
        store.state.user.token
  },
  mounted() {
    window.addEventListener('message', this.initMessage, false)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.initMessage)
  },
  methods: {
    initMessage(e) {
      const frame = document.getElementById('frameWrapper').contentWindow
      var u = navigator.userAgent
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
      if (e.data && e.data.plusType) {
        try {
          CSCEC[e.data.plusType]({
            success(result) {
              if (isAndroid && e.data.plusType === 'getGeolocation') {
                result = JSON.parse(result)
              }
              frame.postMessage(
                { cscecResult: 'success', ...result, ...e.data },
                '*'
              )
            },
            fail(err) {
              frame.postMessage(err, '*')
            },
          })
        } catch (err) {
          frame.postMessage(err, '*')
          throw new Error(err)
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
